import React, { useEffect, useState } from 'react';
import NovaNotificacao from '../../../../service/NovaNotificacao';
import AttToken from '../../../../helpers/attToken';
import {
  Accordion,
  AccordionSummary,
  Autocomplete,
  Button,
  Chip,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  NativeSelect,
  Paper,
  Skeleton,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ChecklistType, notifiConfigType } from '../../../../service/Checklists';
import { trackEventMatomo } from '../../../../helpers/matomo';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import QueryFn from '../../../../helpers/QueryFn';

const newNotfiService = new NovaNotificacao();
const queryFn = new QueryFn();

type props = {
  form: ChecklistType,
};

type returnType = {
  tipoId: string,
  nome: string,
  notifis: { nome: string, id: string }[]
};

type propsNotifis = {
  notifiConfig: notifiConfigType[],
  setNotifiConfig: React.Dispatch<React.SetStateAction<notifiConfigType[]>>,
  findNotifiNome: Function,
  obj: returnType,
  t: Function,
  expanded: string | boolean,
  handleChange: Function,
};

const NotifisByType = ({ notifiConfig, setNotifiConfig, findNotifiNome, obj, t, expanded, handleChange }: propsNotifis) => {
  const [selectedNotifis, setSelectedNotifis] = useState<notifiConfigType[]>(
    obj.notifis.filter(noti => notifiConfig.some(conf => conf.id === noti.id))
      ?.map(e => {
        const notifiEm = notifiConfig.find(el => el.id === e.id)?.notifiEm || 'sempre';
        return { id: e.id, notifiEm };
      })
  );

  return (
    <>
      <Accordion expanded={expanded === obj.tipoId} style={{ padding: "10px 5px 10px 5px", width: '100%' }}>
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
              onClick={(isExpanded) => {
                if (expanded === obj.tipoId) {
                  handleChange(!isExpanded, '');
                } else
                  handleChange(isExpanded, obj.tipoId);
              }} />}
          aria-controls="panel1a-content"
          id="panel1a-header">
          Notificacoes do tipo -&nbsp;<b>{obj.nome}</b>
        </AccordionSummary>
        {selectedNotifis.length > 0 && selectedNotifis?.map((ele, i: number) => (
          <>
            <Stack
              direction="row"
              justifyContent='space-between'
              alignItems="center"
              width={'100%'}
              sx={{
                padding: '10px',
                marginTop: '5px',
                marginBottom: '5px',
                backgroundColor: '#E3E3E3'
              }}
              key={ele.id}
            >
              <Typography variant='body2'>{findNotifiNome(ele.id)}</Typography>
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={0.5}
              >
                <FormControl variant='standard' style={{ width: '120px' }}>
                  <InputLabel>Notificar em:</InputLabel>
                  <NativeSelect
                    style={{ fontSize: '12px' }}
                    inputProps={{
                      name: 'Notificar em:'
                    }}
                    variant='standard'
                    defaultValue={selectedNotifis[i].notifiEm}
                    onClick={() => trackEventMatomo('modal config form', 'click', 'select', 'seleciona status')}
                    onChange={(e) => {
                      selectedNotifis[i].notifiEm = e.target.value;
                      notifiConfig.forEach((conf) => {
                        if (conf.id === ele.id) {
                          conf.notifiEm = e.target.value;
                          setNotifiConfig([...notifiConfig]);
                        }
                      });
                      setSelectedNotifis(selectedNotifis);
                    }}
                  >
                    <option value='sempre'>{t('checklists.formModal.always')}</option>
                    <option value='naoConformidade'>{t('checklists.formModal.inNonConformity')}</option>
                  </NativeSelect>
                </FormControl>
                <RemoveCircleIcon
                  fontSize='large'
                  color='error'
                  onClick={() => {
                    setSelectedNotifis(prev => prev ? prev.filter(el => el.id !== ele.id) : []);
                    setNotifiConfig(prev => prev ? prev.filter(el => el.id !== ele.id) : []);
                  }}
                />
              </Stack>
            </Stack>
            <Divider />
          </>
        ))}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Paper
            component="form"
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
          >
            <Autocomplete
              multiple
              fullWidth
              filterSelectedOptions
              disablePortal
              disabled={selectedNotifis?.length === obj.notifis?.length}
              id="combo-box-demo"
              defaultValue={selectedNotifis?.map((ele) => {
                return (
                  {
                    id: ele?.id,
                    nome: obj.notifis?.find((elem) => elem.id === ele.id)?.nome,
                    notifiEm: ele.notifiEm
                  }
                );
              }) || undefined}
              options={obj.notifis
                ?.filter((ele) => !selectedNotifis?.some((elem) => elem.id === ele.id))
                ?.sort((a: { id: string, nome: string }, b: { id: string, nome: string }) => {
                  return a.nome?.toLowerCase()
                    > b.nome?.toLowerCase() ? 1 : - 1;
                })?.map((notif) => {
                  return ({
                    id: notif?.id,
                    nome: notif?.nome,
                    notifiEm: 'sempre'
                  });
                }) || []}
              renderTags={(tagValue, getTagProps) => {
                return tagValue?.map((option, index) => (
                  <Chip {...getTagProps({ index })} key={option.id} label={option.nome} />
                ));
              }}
              renderOption={(props, option) => (
                <li {...props} key={option?.id}>
                  <span>{option?.nome}</span>
                </li>)}
              onChange={(elem, value, result, options) => {
                if (notifiConfig.includes(options?.option.id as any)) {
                  setNotifiConfig(notifiConfig.filter((ele) => ele.id !== options?.option.id));
                } else {
                  setNotifiConfig([...notifiConfig, { id: (options?.option.id as string), notifiEm: 'sempre' }]);
                }
                setSelectedNotifis(value);
              }}
              renderInput={(params) => <TextField {...params} label="Notificações" />}
            />
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton>
              <Button
                variant='contained'
                color='primary'
                style={{ padding: '10px', fontSize: '12px' }}
                className='button is-info'
                endIcon={<AddToPhotosIcon />}
                disabled={obj.notifis?.every(notifis => notifiConfig?.some(conf => conf.id === notifis.id))}
                onClick={() => {
                  const all: notifiConfigType[] = obj
                    .notifis
                    .filter(el => !notifiConfig.some(conf => conf.id === el.id))
                    .map(e => ({ id: e.id, notifiEm: 'sempre' }));

                  if (all.length) {
                    setNotifiConfig((prev) => prev ? [...prev, ...all] : all);
                    setSelectedNotifis(prev => prev ? [...prev, ...all] : all);
                  }
                }}
              >
                {t('checklists.formModal.addAll')}
              </Button>
            </IconButton>
          </Paper>
        </div>
      </Accordion>
    </>
  );
};

export default function NotifiConfig({ form }: props) {
  const [notifiConfig, setNotifiConfig] = useState<notifiConfigType[]>(form.notifiConfig || []);
  const [selectedServicesTypes, setSelectedServicesTypes] = useState<returnType[] | null>(null);

  const [expanded, setExpanded] = useState<string | boolean>(false);

  const handleChange = (isExpanded: boolean, panel: string) => {
    setExpanded(isExpanded ? panel : false);
    trackEventMatomo('modal config form', 'click', 'acordeon', 'abre/fecha');
  };

  const { t } = useTranslation('translation');

  const getNotifiFn = async () => {
    try {
      const token = await AttToken();
      if (token) {
        const body = { ...token, empresa: token.userEmpresa };
        const result: returnType[] = await newNotfiService.getAllByTypes(body);
        const selecteds: returnType[] = [];
        result.forEach(objConfig => {
          if (form.notifiConfig && form.notifiConfig.some(config => objConfig.notifis.some(notifi => notifi.id === config.id))) {
            selecteds.push(objConfig);
          }
        });
        if (selecteds && selecteds.length) {
          setSelectedServicesTypes(selecteds);
        }
        return result;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getNotifi = queryFn.useFetch('NOTIFICATIONS_BY_SERVICE', getNotifiFn);

  const findNotifiNome = (id: string) => {
    const thisServiceNotifis = getNotifi.data?.find((obj: any) => obj.notifis.some((notifi: any) => notifi.id === id))?.notifis;
    if (thisServiceNotifis && thisServiceNotifis.length) {
      return thisServiceNotifis?.find((ele: any) => ele.id === id)?.nome || 'Nome não encontrado';
    } else { return 'Nome não encontrado'; }
  };

  useEffect(() => {
    form.notifiConfig = notifiConfig;
  }, [notifiConfig]);

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      {

        getNotifi.isLoading || getNotifi.isRefetching ?
          <>
            <Skeleton variant='rounded' width={'75%'} height={30} />
            <Skeleton variant='rounded' width={'100%'} height={40} />
          </> :
          <>
            <Typography variant='h6'>{t('checklists.formModal.serviceTypesNotifiedByForm')}</Typography>
            <Autocomplete
              defaultValue={selectedServicesTypes?.map((ele) => {
                return (
                  {
                    tipoId: ele?.tipoId,
                    nome: ele?.nome,
                    notifis: ele?.notifis,
                  }
                );
              }) || undefined}
              filterSelectedOptions
              disableClearable
              multiple
              fullWidth
              options={getNotifi.data?.sort((a: any, b: any) => { return a.nome?.toLowerCase() > b.nome?.toLowerCase() ? 1 : - 1; })
                ?.filter((ele: any) => !selectedServicesTypes?.some((elem) => elem.tipoId === ele.tipoId))
                ?.map((notif: returnType) => {
                  return ({
                    tipoId: notif?.tipoId,
                    nome: notif?.nome,
                    notifis: notif?.notifis,

                  });
                }) || []}
              renderTags={(tagValue, getTagProps) => {
                return tagValue?.map((option, index) => (
                  <Chip {...getTagProps({ index })} key={option.tipoId} label={option.nome} />
                ));
              }}
              renderInput={(params) => <TextField {...params} label={t('checklists.formModal.selectServiceType')} />}
              onChange={(eve, value) => {
                setSelectedServicesTypes(value as returnType[]);
              }}
              renderOption={(props, option) => (
                <li {...props} key={option?.tipoId}>
                  <span>{option?.nome}</span>
                </li>)}
            />
            {selectedServicesTypes && selectedServicesTypes?.length > 0 && selectedServicesTypes?.map(obj => (
              <NotifisByType
                key={obj.tipoId}
                expanded={expanded}
                handleChange={handleChange}
                notifiConfig={notifiConfig}
                setNotifiConfig={setNotifiConfig}
                findNotifiNome={findNotifiNome}
                obj={obj}
                t={t}
              />
            ))}
          </>
      }
    </Stack>
  );
}